import { CNIC_HAWAII_RESOURCE_NOTES_PREFIX } from '../NotificationsTab/cnicHawaiiThreatNotification';
import { DHS_REGION4_RESOURCE_NOTES_PREFIX } from '../NotificationsTab/dhsRegion4ThreatNotification';
import {
  EPA_GULF_LEGACY_RESOURCE_NOTES_PREFIX,
  EPA_GULF_RESOURCE_NOTES_PREFIX,
} from '../NotificationsTab/epaGulfThreatNotification';
import { EQUINOR_GRANE_RESOURCE_NOTES_PREFIX } from '../NotificationsTab/equinorGraneSpillNotification';
import {
  JAPAN_RESOURCE_NOTES_PREFIX,
  JAPAN_RESPONSE_RESOURCE_NOTES_PREFIX,
} from '../NotificationsTab/japanEarthquakeNotification';
import { HELENE_CONE_RESOURCE_NOTES_PREFIX } from '../NotificationsTab/memphisThreatNotification';
import { ONTARIO_GTA_RESOURCE_NOTES_PREFIX } from '../NotificationsTab/ontarioSnowstormNotification';
import { TNNG_MEMPHIS_RESOURCE_NOTES_PREFIX } from '../NotificationsTab/tennesseeMemphisThreatNotification';
import { USCG_FOC_SE_RESOURCE_NOTES_PREFIX } from '../NotificationsTab/uscgFocSoutheastThreatNotification';

/** `notes` prefixes the demo seeders stamp on the assets they create. */
export const DEMO_ASSET_NOTES_PREFIXES: string[] = [
  EQUINOR_GRANE_RESOURCE_NOTES_PREFIX,
  DHS_REGION4_RESOURCE_NOTES_PREFIX,
  USCG_FOC_SE_RESOURCE_NOTES_PREFIX,
  EPA_GULF_RESOURCE_NOTES_PREFIX,
  EPA_GULF_LEGACY_RESOURCE_NOTES_PREFIX,
  CNIC_HAWAII_RESOURCE_NOTES_PREFIX,
  ONTARIO_GTA_RESOURCE_NOTES_PREFIX,
  JAPAN_RESOURCE_NOTES_PREFIX,
  JAPAN_RESPONSE_RESOURCE_NOTES_PREFIX,
  HELENE_CONE_RESOURCE_NOTES_PREFIX,
  TNNG_MEMPHIS_RESOURCE_NOTES_PREFIX,
];

export function isSeededDemoAsset(resource: {
  notes?: string | null;
}): boolean {
  const notes = resource.notes ?? '';
  return DEMO_ASSET_NOTES_PREFIXES.some((prefix) => notes.startsWith(prefix));
}
